// Consume bearer fragments before analytics or widget code can observe them.
// The secret is exchanged once and is never kept in browser storage.
export class ViewLinkError extends Error {}
let pending:
  { pageId: string; instance: string; exchange: Promise<void> } | undefined;
function consume() {
  const url = new URL(location.href);
  const fragment = new URLSearchParams(url.hash.slice(1));
  if (!fragment.has("gardenAccess")) return false;
  const token = fragment.get("gardenAccess");
  fragment.delete("gardenAccess");
  url.hash = fragment.toString();
  history.replaceState(history.state, "", url);
  const match = url.pathname.match(
    /^\/(?:app\/[^/]+\/)?v\/([a-zA-Z0-9_-]{1,64})\/([a-zA-Z0-9_-]{1,64})$/,
  );
  if (!match) return false;
  const [, pageId, instance] = match;
  const exchange = (async () => {
    const response = await fetch(
      `/api/views/${pageId}/${instance}/link-session`,
      {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      },
    );
    if (!response.ok) {
      const result = (await response.json()) as { error?: string };
      throw new ViewLinkError(
        result.error || "This widget link is unavailable.",
      );
    }
  })();
  pending = { pageId, instance, exchange };
  void exchange.catch(() => {});
  return true;
}
if (typeof location !== "undefined") consume();
if (typeof addEventListener !== "undefined")
  addEventListener("hashchange", () => {
    if (consume()) dispatchEvent(new Event("garden:view-link"));
  });
export async function openViewLink(pageId: string, instance: string) {
  if (pending?.pageId === pageId && pending.instance === instance)
    await pending.exchange;
}
